
  import {
    Options,
    Vue
  } from 'vue-class-component';
  import MainVisual from '@/components/MainVisual.vue';

  import 'vue3-carousel/dist/carousel.css';
  import {
    Carousel,
    Slide,
    Pagination,
    Navigation
  } from 'vue3-carousel';


  @Options({
    data: function () {
      return {
        faq: [{
            q: 'What is a dog?',
            a: 'A dog is a cute dog.',
            opened: false
          },
          {
            q: 'where is a dog?',
            a: 'A dog is not actually a dog.<strong>They are aliens who want to be dogs.</strong>',
            opened: false
          },
          {
            q: 'When I am a dog, what do I do?',
            a: 'They are aliens who want to be dogs.',
            opened: false
          },
        ],
        gallerySlide: [{
            filename: "000.jpg"
          },
          {
            filename: "001.jpg"
          },
          {
            filename: "002.jpg"
          },
          {
            filename: "003.jpg"
          },
          {
            filename: "004.jpg"
          },
          {
            filename: "005.jpg"
          },
          {
            filename: "006.jpg"
          },
          {
            filename: "007.jpg"
          },
          {
            filename: "008.jpg"
          },
          {
            filename: "009.jpg"
          },
          {
            filename: "010.jpg"
          },
        ],
        creators: [{
            name: "Lorem A Ipsum",
            role: "Graphic lord",
            avatar: "/images/gallery/001.jpg",
            socialMedia: {
              facebook: "https://www.facebook.com/",
              twitter: "https://www.twitter.com/",
              instagram: "https://www.instagram.com/",
              youtube: "https://www.youtube.com/",
            }
          },
          {
            name: "Lorem A Ipsum",
            role: "Graphic lord",
            avatar: "/images/gallery/002.jpg",
            socialMedia: {
              facebook: "https://www.facebook.com/",
              twitter: "https://www.twitter.com/",
              instagram: "https://www.instagram.com/",
              youtube: "https://www.youtube.com/",
            }
          },
          {
            name: "Lorem A Ipsum",
            role: "Graphic lord",
            avatar: "/images/gallery/003.jpg",
            socialMedia: {
              facebook: "https://www.facebook.com/",
              twitter: "https://www.twitter.com/",
              instagram: "https://www.instagram.com/",
              youtube: "https://www.youtube.com/",
            }
          },
        ]
      }
    },
    components: {
      MainVisual,
      Carousel,
      Slide,
      Pagination,
      Navigation,
    },
  })
  export default class HomeView extends Vue {}
